export default {
  queryHistoryPointDetail: '/courier-sqp-api/h5/v1/queryHistoryPointDetail'
}
